export default __webpack_public_path__ + "static/media/Get_Paid_for_Spreading_Love_and_Happiness.470d87af.webp";